import { useState } from "react";
import { ShieldAlert, ShieldCheck, ShieldQuestion, Loader2, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/PageHeader";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const V = {
  truffa: [ShieldAlert, "È una truffa", "bg-red-600 text-white"],
  sospetto: [ShieldQuestion, "Sospetto: fai attenzione", "bg-amber-500 text-white"],
  sembra_affidabile: [ShieldCheck, "Sembra affidabile", "bg-emerald-600 text-white"],
};

const List = ({ title, items }) => (items?.length ? <div><p className="font-medium">{title}</p><ul className="mt-2 list-disc pl-5 space-y-1 text-slate-700">{items.map((x) => <li key={x}>{x}</li>)}</ul></div> : null);

export default function ScamCheck() {
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const check = async () => {
    const fd = new FormData();
    fd.append("text", text);
    if (file) fd.append("file", file);
    setBusy(true);
    setRes(null);
    try {
      const { data } = await api.post("/ai/scam", fd);
      setRes(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const [Icon, label, cls] = V[res?.verdetto] || V.sospetto;

  return (
    <div data-testid="scam-page">
      <PageHeader eyebrow="Anti-truffa" title="È una truffa?" desc="Incolla un SMS, un'email o un messaggio WhatsApp sospetto, oppure carica uno screenshot." />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="rounded-3xl border bg-white p-6 space-y-4 h-fit">
          <Textarea rows={8} value={text} onChange={(e) => setText(e.target.value)} placeholder="es. Il tuo pacco è in giacenza, paga 1,99 € su questo link…" data-testid="scam-text-input" />
          <label className="flex items-center gap-2 text-sm text-slate-600"><Upload className="h-4 w-4" /><Input type="file" accept="image/jpeg,image/png,image/webp" onChange={(e) => setFile(e.target.files[0])} data-testid="scam-file-input" /></label>
          <Button onClick={check} disabled={busy || (!text.trim() && !file)} className="rounded-full" data-testid="scam-check-btn">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Controlla</Button>
          <p className="text-xs text-slate-500">Non cliccare link e non inserire dati finché non hai verificato. Banche ed enti pubblici non chiedono mai password o PIN via messaggio.</p>
        </div>
        {res && (
          <div className="space-y-4 fade-up" data-testid="scam-result">
            <div className={`rounded-3xl p-6 flex items-center gap-4 ${cls}`}><Icon className="h-10 w-10" /><div><p className="text-2xl font-display font-semibold" data-testid="scam-verdict">{label}</p><p className="text-sm opacity-90">Affidabilità del giudizio: {res.sicurezza}</p></div></div>
            <div className="rounded-3xl border bg-white p-6 space-y-4">
              <List title="Segnali trovati" items={res.motivi} />
              <List title="Cosa fare" items={res.cosa_fare} />
              <List title="Cosa NON fare" items={res.non_fare} />
              {res.canale_ufficiale && <p className="text-sm"><b>Come verificare:</b> {res.canale_ufficiale}</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
